import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'

const isNative = Capacitor.isNativePlatform()

export async function getSecureItem(key: string): Promise<string | undefined> {
  if (isNative) {
    const { value } = await Preferences.get({ key })
    return value ?? undefined
  }
  return localStorage.getItem(key) ?? undefined
}

export async function setSecureItem(key: string, value: string): Promise<void> {
  if (isNative) {
    await Preferences.set({ key, value })
    return
  }
  localStorage.setItem(key, value)
}

export async function removeSecureItem(key: string): Promise<void> {
  if (isNative) {
    await Preferences.remove({ key })
    return
  }
  localStorage.removeItem(key)
}

export async function clearSecureStorage(): Promise<void> {
  if (isNative) {
    await Preferences.clear()
    return
  }
  localStorage.clear()
}
